import React, { useState } from 'react';

import { CloseIcon } from '../icons';
import TextField from '../text-field';
import Checkbox from '../checkbox';

import './styles.css';
// import DialogButton from "../dialogButton"

const initialState = {
    first: '',
    last: '',
    dispensary: '',
    phone: '',
    email: '',
    state: '',
    inventory: false,
    reporting: false,
    compliance: false,
    loyalty: false,
    training: false,
    fire: false,
    other: '',
};

const ContactDialog = ({ isOpen, onClose, onSubmit }) => {
    const [state, setState] = useState(initialState);
    const [hasSubmitted, setHasSubmitted] = useState(
        typeof window !== 'undefined' && window.sessionStorage
            ? sessionStorage.getItem('contact-submit')
            : null
    );

    const DialogClose = () => (
        <div className="dialog-close" onClick={handleClose}>
            <CloseIcon />
        </div>
    );

    const handleClose = e => {
        // Pass boolean to `onClose()` to indicate if we've successfully submitted.
        onClose(!hasSubmitted);
    };

    const handleSubmit = e => {
        e.preventDefault();

        // Invoke Google's reCAPTCHA test.
        // `window.grecaptcha` is loaded via `<script>` tag in `/seo/index.js`
        window.grecaptcha.ready(function () {
            window.grecaptcha
                .execute('6LcrzK4ZAAAAADyM2yyjEcZaZz7pAX1uvBmzmg8C', {
                    action: 'contactDialogSubmit',
                })
                .then(function (token) {
                    // Note this test provides a "score" (ranging from 0.0 - 1.0),
                    // and not a "pass" or "fail". Backend determines what to do
                    // based on score.
                    onSubmit(state, token).then(
                        response => {
                            console.log('response', response);
                            if (response.ok) {
                                setState(initialState);
                                setHasSubmitted(true);
                                if (
                                    typeof window !== undefined &&
                                    window.sessionStorage
                                ) {
                                    sessionStorage.setItem(
                                        'contact-submit',
                                        Date.now()
                                    );
                                }
                            }
                        },
                        err => {
                            alert(err);
                        }
                    );
                });
        });
    };

    const PhoneLink = () => <a href="tel:7205757030">(720)&nbsp;575-7030</a>;

    return (
        <div className="dialog">
            {isOpen ? (
                <div className="dialog-overlay" onClick={handleClose}>
                    {hasSubmitted ? (
                        <div className="dialog-content success-message">
                            <div className="dialog-head">
                                <DialogClose></DialogClose>
                                <h3>Thanks for Reaching Out</h3>
                            </div>
                            <div className="dialog-body">
                                <p>
                                    We have received your details and appreciate
                                    you contacting us. Someone from Weave will
                                    get in touch soon.
                                </p>
                                <p>
                                    Can't wait? Give us a call now:{' '}
                                    <PhoneLink></PhoneLink>
                                </p>
                            </div>
                            <div className="dialog-footer">
                                <button className="close" onClick={handleClose}>
                                    close
                                </button>
                            </div>
                        </div>
                    ) : (
                        <form
                            className="dialog-content form"
                            onSubmit={handleSubmit}
                            onClick={e => e.stopPropagation()}
                        >
                            <div className="dialog-head">
                                <DialogClose></DialogClose>
                                <h3>Get to Know Weave</h3>
                                <p>
                                    Fill out the information below so we can
                                    answer your questions about Weave.
                                </p>
                                <p>
                                    Want to talk to a human right away? Give us
                                    a call: <PhoneLink></PhoneLink>.
                                </p>
                            </div>
                            <div className="dialog-body">
                                <div className="text-fields">
                                    <TextField
                                        label="First Name"
                                        value={state.first}
                                        onChange={e =>
                                            setState({
                                                ...state,
                                                first: e.target.value,
                                            })
                                        }
                                        required={true}
                                    />
                                    <TextField
                                        label="Last Name"
                                        value={state.last}
                                        onChange={e =>
                                            setState({
                                                ...state,
                                                last: e.target.value,
                                            })
                                        }
                                    />
                                    <TextField
                                        label="Company Name (Optional)"
                                        value={state.dispensary}
                                        onChange={e =>
                                            setState({
                                                ...state,
                                                dispensary: e.target.value,
                                            })
                                        }
                                    />
                                    <TextField
                                        label="Phone"
                                        value={state.phone}
                                        onChange={e =>
                                            setState({
                                                ...state,
                                                phone: e.target.value,
                                            })
                                        }
                                        required={true}
                                    />
                                    <TextField
                                        label="Email"
                                        value={state.email}
                                        onChange={e =>
                                            setState({
                                                ...state,
                                                email: e.target.value,
                                            })
                                        }
                                    />
                                    <TextField
                                        label="State"
                                        value={state.state}
                                        onChange={e =>
                                            setState({
                                                ...state,
                                                state: e.target.value,
                                            })
                                        }
                                    />
                                </div>
                                <h4>I want to learn more about...</h4>

                                <div className="checkboxes">
                                    <Checkbox
                                        label="Compliance & Inventory"
                                        checked={state.compliance}
                                        onCheck={e =>
                                            setState({
                                                ...state,
                                                compliance: !state.compliance,
                                            })
                                        }
                                    />
                                    <Checkbox
                                        label="Online Ordering"
                                        checked={state.ordering}
                                        onCheck={e =>
                                            setState({
                                                ...state,
                                                ordering: !state.ordering,
                                            })
                                        }
                                    />
                                    <Checkbox
                                        label="Analytics"
                                        checked={state.analytics}
                                        onCheck={e =>
                                            setState({
                                                ...state,
                                                analytics: !state.analytics,
                                            })
                                        }
                                    />
                                    <Checkbox
                                        label="Customer Loyalty"
                                        checked={state.loyalty}
                                        onCheck={e =>
                                            setState({
                                                ...state,
                                                loyalty: !state.loyalty,
                                            })
                                        }
                                    />
                                    <Checkbox
                                        label="Training"
                                        checked={state.training}
                                        onCheck={e =>
                                            setState({
                                                ...state,
                                                training: !state.training,
                                            })
                                        }
                                    />
                                    <Checkbox
                                        label="Everything is on fire"
                                        checked={state.fire}
                                        onCheck={e =>
                                            setState({
                                                ...state,
                                                fire: !state.fire,
                                            })
                                        }
                                    />
                                </div>
                                <h4>I would also like to learn more about…</h4>
                                <div className="more-info">
                                    <TextField
                                        label="What else would you like to know?"
                                        value={state.other}
                                        onChange={e =>
                                            setState({
                                                ...state,
                                                other: e.target.value,
                                            })
                                        }
                                        multiline={true}
                                    />
                                </div>
                            </div>
                            <div className="dialog-footer">
                                <div className="recaptcha-disclaimer">
                                    This site is protected by reCAPTCHA, and the
                                    Google{' '}
                                    <a href="https://policies.google.com/privacy">
                                        Privacy Policy
                                    </a>{' '}
                                    and{' '}
                                    <a href="https://policies.google.com/terms">
                                        Terms of Service
                                    </a>{' '}
                                    apply.
                                </div>
                                <button type="submit">Submit</button>
                            </div>
                        </form>
                    )}
                </div>
            ) : null}
        </div>
    );
};

export default ContactDialog;
